import { styled } from "@mui/material/styles";
import { pxToRem } from "@getbread/dough";
import { FormattedMessage } from "react-intl";
import { PageContainer } from "../../PageContainer/PageContainer";
import { Header } from "../../Header/Header";
import { useIsSystemicChargeOffBuyer } from "../../../utils/useIsSystemicChargeOffBuyer";
import { getConfig } from "../../../utils/getConfig";
import { InvalidJwtErrorBoundary } from "../../InvalidJwtErrorBoundary/InvalidJwtErrorBoundary";

const Heading = styled("h1")`
	font-size: ${pxToRem(24)};
	font-weight: 800;
`;

const Content = styled("div")`
	font-size: ${pxToRem(18)};
`;

const WhitePageContainer = styled(PageContainer)`
	background-color: white;
	padding: var(--space-l);
`;

const Link = styled(`a`)`
	color: ${(props) => props.theme.palette.primary.main};
`;

/* This is used to check whether a user is deceased or fraudulent confirmed, if they are they will see this error page ; not applicable to RBC */
const RawUserAccessGuard = ({ children }: { children: React.ReactNode }) => {
	const { isDeceasedConfirmed, isFraudClaimConfirmed } = useIsSystemicChargeOffBuyer();

	const getInTouchLink = getConfig("getintouch");

	return (
		<>
			{isDeceasedConfirmed || isFraudClaimConfirmed ? (
				<>
					<Header />
					<WhitePageContainer>
						<Heading>
							<FormattedMessage defaultMessage="We’re unable to complete your request" />
						</Heading>
						<Content data-testid="user-access-guard-content">
							<FormattedMessage
								defaultMessage="If you need help or want to make a payment, please <a>contact us</a>."
								values={{
									a: (chunks) => (
										<Link
											data-testid="contact-us-link"
											href={getInTouchLink}
											target="_blank"
											rel="noreferrer"
										>
											{chunks}
										</Link>
									),
								}}
							/>
						</Content>
					</WhitePageContainer>
				</>
			) : (
				children
			)}
		</>
	);
};

export const UserAccessGuard = ({ children }: { children: React.ReactNode }) => (
	// Since RawUserAccessGuard makes API calls, we need to wrap it in an InvalidJwtErrorBoundary
	<InvalidJwtErrorBoundary>
		<RawUserAccessGuard>{children}</RawUserAccessGuard>
	</InvalidJwtErrorBoundary>
);
